export const driveServicePaths = {
  logisticsGroundTrips: `/groundtripservice/logistics/ground-trips`,
} as const;

export const getDriveServiceApiUrl = {
  logisticsGroundTrips: () => driveServicePaths.logisticsGroundTrips,
};
